import { Typography } from 'antd';
import clsx from 'clsx';
import React from 'react';
const Text = ({ children, className = '', inherit = true, ...rest }) => {
    return (React.createElement(Typography.Text, { className: clsx([className, inherit ? 'text-inherit' : '']), ...rest }, children));
};
export default Text;
